import Component from './TwitterAnalyticsPublicChartFollower.vue'
export default Component
